import React from "react";
import Button from "./Button";
import AddressForm from "./AddressForm";

const EditProperty = (props) => {
  const { cancelEditProperty, updateProperty } = props;
  return (
    <div
      className="w-screen h-screen fixed top-0 left-0 right-0 bottom-0 bg-white 
      mt-20 overflow-y-auto overscroll-none z-30"
    >
      <div className="flex justify-center text-xl mt-10">Edit Address:</div>
      <div className="grid justify-items-center">
        <AddressForm edit={true} />
      </div>
      <div className="flex justify-center w-full mt-10 mb-40">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Cancel"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={cancelEditProperty}
        />
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Update"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={updateProperty}
        />
      </div>
    </div>
  );
};

export default EditProperty;
